import React from 'react';
const stats = [{
  value: '26',
  label: 'Weeks'
}, {
  value: '78',
  label: 'Complete workouts'
}, {
  value: '3',
  label: 'Sessions per week'
}, {
  value: '2',
  label: 'Workload options'
}];
const levels = ['Foundation Option', 'Standard Option', 'Mixed-Level Classes', 'Limited Equipment', 'Independent Trainees', 'Printable PDF'];
export function CompleteSystem() {
  return <section aria-labelledby="system-heading" className="bg-white" data-id="element-56" data-mp="1fjqjv71vqdmr">
      <div className="mx-auto max-w-5xl px-5 py-16 text-center md:py-24" data-id="element-57" data-mp="1fiffp64iv3v4">
        <h2 id="system-heading" className="font-display text-[3.25rem] font-extrabold uppercase leading-[0.9] text-forest sm:text-6xl md:text-7xl" data-id="element-58" data-mp="1kik0h8cgqkr5">
          Hyrox <span className="text-gold-dark" data-id="element-59" data-mp="1ajkq9lc1uh21">Mega Pack™</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-forest/80" data-id="element-60" data-mp="3r9jh22em20tw">
          One training-plan book organized into six blocks: 78 complete workouts, warm-ups, equipment alternatives,
          mixed-level tools and progress trackers — all done for you.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-forest/70" data-id="element-61" data-mp="285yecxpvir1d">
          Made for HYROX, gym and fitness instructors who want their upcoming weeks organized: open the plan, pick the
          level, and bring a complete session to class.
        </p>

        <dl className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-4" data-id="element-62" data-mp="2i68o28cp9gbs">
          {stats.map(s => <div key={s.label} className="rounded-xl border border-forest/10 bg-mint px-4 py-7" data-id="element-63" data-mp="2w1av4yta9bq6">
              <dt className="sr-only" data-id="element-64" data-mp="2r2q0dewsvk94">{s.label}</dt>
              <dd data-id="element-65" data-mp="35s5f1wj23z8g">
                <span className="block font-display text-5xl font-extrabold leading-none text-forest md:text-6xl" data-id="element-66" data-mp="35snknjrlzpt1">
                  {s.value}
                </span>
                <span className="mt-2 block text-xs font-bold uppercase tracking-[0.14em] text-gold-dark" data-id="element-67" data-mp="3etd9u4md6hxs">{s.label}</span>
              </dd>
            </div>)}
        </dl>

        <ul className="mt-8 flex flex-wrap justify-center gap-2.5" data-id="element-68" data-mp="27i5w32ryw7rx">
          {levels.map(c => <li key={c} className="rounded-full border border-gold/40 bg-gold-cream px-4 py-2 text-sm font-semibold text-forest" data-id="element-69" data-mp="2cg7fjotb293x">
              {c}
            </li>)}
        </ul>
      </div>
    </section>;
}